import { NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  input,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { CollapseComponent } from '../collapse/collapse.component';

/**
 * Menu header for collapsible container. Functions as trigger to open/close the container.
 */
@Component({
  standalone: true,
  selector: 'ct-lib-collapse-menu',
  templateUrl: './collapse-menu.component.html',
  styleUrls: ['./collapse-menu.component.scss'],
  imports: [NgTemplateOutlet, FaIconComponent, CollapseComponent],
  host: {
    class: 'd-block mb-3',
  },
})
export class CollapseMenuComponent implements AfterViewInit {
  @Input() label: string | null = null;
  @Input() header: TemplateRef<any>;
  @Input() open = false;
  @Input() chat = false;
  @Input() own = false;
  @Input() failed = false;
  collapsable = input<boolean>(true);
  @Output() onChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  animationsDisabled = true;
  faChevronDown = faChevronDown;

  public forceOpen = false;

  toggleCollapse(): void {
    if (!this.collapsable()) {
      return;
    }
    this.open = this.forceOpen ? true : !this.open;
    this.onChange.emit(this.open);
  }

  openCollapse(): void {
    if (!this.collapsable()) {
      return;
    }
    this.open = true;
    this.onChange.emit(this.open);
  }

  closeCollapse(): void {
    if (!this.collapsable()) {
      return;
    }
    this.open = false;
    this.onChange.emit(this.open);
  }

  ngAfterViewInit(): void {
    this.animationsDisabled = false;
  }
}
